import { render, staticRenderFns } from "./HeaderManageGroupTeacher.vue?vue&type=template&id=1a58d292&scoped=true"
import script from "./HeaderManageGroupTeacher.vue?vue&type=script&lang=js"
export * from "./HeaderManageGroupTeacher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a58d292",
  null
  
)

export default component.exports